<div class="comment-content-container">
    <table mat-table matSort [dataSource]="dataSource">
        <ng-container matColumnDef="oldGrade">
            <th mat-header-cell *matHeaderCellDef   sortActionDescription="Sort by Prior Grade" >Prior Grade</th>
            <td mat-cell *matCellDef="let changeHistory">{{changeHistory.oldGrade}}</td>
        </ng-container>
        <ng-container matColumnDef="newGrade">
            <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by New Grade"  >New Grade</th>
            <td mat-cell *matCellDef="let changeHistory">{{changeHistory.newGrade}}</td>
        </ng-container>
        <ng-container matColumnDef="submitDate">
            <th mat-header-cell *matHeaderCellDef  sortActionDescription="Sort by Submitted On"  >Submitted On</th>
            <td mat-cell *matCellDef="let changeHistory">{{changeHistory.submitDate | date: 'MM/dd/yyyy hh:mm a'}}</td>
        </ng-container>
        <ng-container matColumnDef="submittedBy">
            <th mat-header-cell *matHeaderCellDef  sortActionDescription="Sort by Submitted By"  >Submitted By</th>
            <td mat-cell *matCellDef="let changeHistory">{{changeHistory.submittedBy}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator showFirstLastButtons id="gradeChangeHistoryPaginator" class="do-not-show"></mat-paginator>

    <app-button-list>
        <app-button (clickedEvent)="onClose()" [icon]="'close'">Close </app-button>
    </app-button-list>
</div>
